import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import SEO, { pageSEO } from "./seo.component";
import { useUserParams } from "../hooks/useUserParams";

export default function About() {
  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
    getCurrentAbout,
    getCurrentHeadshot
  } = useUserParams();

  const seoConfig = pageSEO.about();
  return (
    <>
      <SEO {...seoConfig} />
      <div className="max-w-[1100px] mx-auto gap-x-24 gap-y-12 px-6 grid sm:grid-cols-2 my-12 min-h-[70vh]">
        <div>
          <img src={getCurrentHeadshot()} className="w-full" />
          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black text-3xl">{getCurrentAgentName()}</h2>
            <p className="italic text-lg">
              {getCurrentAgentTitle()}, {getCurrentBrokerage()}
            </p>

            <div className="flex gap-x-5 my-2">
              {Object.entries(constants.SOCIALS)?.map(([k, v]) => (
                <a href={constants.SOCIALS[k]}>
                  <FontAwesomeIcon
                    className="fa-xl text-logo-second"
                    icon={constants.ICONS[k]}
                  />
                </a>
              ))}
            </div>
            <p className="font-semibold text-lg">{getCurrentAgentNumber()} </p>
            <p className="text-lg">{getCurrentAgentEmail()} </p>
          </div>
        </div>
        <div>
          <h1 className="text-4xl text-black pb-8 font-mont ">ABOUT ME</h1>

          <p>{getCurrentAbout()}</p>
        </div>
      </div>
    </>
  );
}
